export default __webpack_public_path__ + "static/media/arrow-next.f913a02b.svg";